// extracted by mini-css-extract-plugin
module.exports = {"Header":"TelemetryAccessDenied_Header__2Uvhi","Text":"TelemetryAccessDenied_Text__19QcS","Card":"TelemetryAccessDenied_Card__11IyK","Logo":"TelemetryAccessDenied_Logo__2nZp-"};